import {
  getAllMyKitsFromServer,
  getMyKitsCategoryFromServer,
} from "logic/services/My-Kits";
import { actionController } from "../utils";
import { getMyNFTKitsFromServer } from "logic/services/NFT-kits/server";
import { getMyTokenKitsFromServer } from "logic/services/Token-Kits/server";
import { getCurrencyFromServer } from "logic/services/currency/server";

export const myKitsController = {
  //유저가 생성한 모든 키트 조회
  getAllMyKits: (option?: {
    lastId?: number;
    offset?: number;
    limit?: number;
    order?: "ASC" | "DESC";
    categoryIds?: number[];
  }) => {
    return actionController(async () => {
      try {
        const kits = await getAllMyKitsFromServer({
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
            ...(option?.categoryIds && {
              categoryIds: option.categoryIds,
            }),
          },
        });

        const nftKitIds: number[] = [];
        const tokenKitIds: number[] = [];
        const originMicroChainIds: number[] = [];

        kits.rows.forEach((kit) => {
          if (kit.service_identifier === "TOKEN_KIT") {
            tokenKitIds.push(kit.resource_identifier);
          }
          if (kit.service_identifier === "NFT_KIT") {
            nftKitIds.push(kit.resource_identifier);
          }
        });

        const nftKits = await getMyNFTKitsFromServer({
          query: {
            nftKitIds,
          },
        });
        const tokenKits = await getMyTokenKitsFromServer({
          query: {
            kitIds: tokenKitIds,
          },
        });

        kits.rows.forEach((kit) => {
          const matchedKit =
            kit.service_identifier === "TOKEN_KIT"
              ? tokenKits.rows.find(
                  (token: any) => token.kit_id === kit.resource_identifier
                )
              : nftKits.rows.find(
                  (nft: any) => nft.nft_kit_id === kit.resource_identifier
                );
          if (matchedKit && matchedKit.chain_id) {
            originMicroChainIds.push(matchedKit.chain_id); // matchedKit에서 chain_id 추출 후 originMicroChainIds에 추가
          }
        });

        // `originMicroChainIds`에 값을 넣은 후, 한 번에 `networkImage`를 가져옵니다.
        const networkImages = await getCurrencyFromServer({
          query: {
            originMicroChainIds: originMicroChainIds,
          },
        });

        const updatedKits = kits.rows.map((kit) => {
          const matchedKit: any =
            kit.service_identifier === "TOKEN_KIT"
              ? tokenKits.rows.find(
                  (token: any) => token.kit_id === kit.resource_identifier
                )
              : nftKits.rows.find(
                  (nft: any) => nft.nft_kit_id === kit.resource_identifier
                );

          if (matchedKit && matchedKit.chain_id) {
            // networkImages에서 chain_id에 맞는 이미지를 찾아서 matchedKit에 추가
            const matchingNetworkImage = networkImages.find(
              (imageData: any) =>
                imageData.origin_micro_chain_id === matchedKit.chain_id
            );
            if (matchingNetworkImage) {
              matchedKit.origin_micro_chain_image = matchingNetworkImage.image;
            }
          }

          return {
            ...kit, // 기존 kit 속성 유지
            kit_data: matchedKit, // kit_data 속성 추가 (없으면 null)
          };
        });

        return {
          count: kits.count,
          rows: updatedKits,
        };
      } catch (e) {
        throw new Error("kits_get_fail");
      }
    });
  },

  //유저가 생성한 모든 키트 조회
  getMyKitsCategoryList: (option?: {
    lastId?: number;
    offset?: number;
    limit?: number;
    order?: "ASC" | "DESC";
  }) => {
    return actionController(async () => {
      try {
        const category = await getMyKitsCategoryFromServer({
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
          },
        });
        return category;
      } catch (e) {
        throw new Error("categoryList_get_fail");
      }
    });
  },
};
